import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/auth';

/**
 * 路由守卫：
 *   - 未登录 → 重定向 /login（保留来源路径，登录后可回跳）
 *   - 已登录访问 /login 的拦截在 Login 页面内处理
 *
 * 用法（布局路由）：
 *   <Route element={<RequireAuth />}>
 *     <Route element={<AppShell />}>...</Route>
 *   </Route>
 */
export default function RequireAuth() {
  const token = useAuthStore((s) => s.token);
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <Outlet />;
}
